import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { EmployeeRoleCreateComponent } from '../../../features/employee/employee-role-create/employee-role-create.component'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatButton } from '@angular/material/button'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { DriverCreateComponent } from '../../../features/driver/driver-create/driver-create.component'
import { DriverEditComponent } from '../../../features/driver/driver-edit/driver-edit.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'driver',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    EmployeeRoleCreateComponent,
    FormSearchComponent,
    MatButton,
    FormClientSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './driver.component.html',
  styleUrl: './driver.component.scss',
  providers: [DriverService, AuthService],
  standalone: true,
})
export class DriverComponent implements OnInit {
  constructor(
    private driverService: DriverService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  // inputSearch: string = ''

  columns: any[] = [
    {
      keyColumn: 'DriveType',
      key: 'tipoMotoristaDescricao',
      description: 'Tipo',
    },
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'isEmployee',
      key: 'motorista',
      description: 'Motorista',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    // {
    //   id: 'tipoMotoristaId',
    //   description: 'Tipo Motorista',
    //   type: 'select',
    //   visible: false,
    // },
    {
      id: 'numeroRegistro',
      description: 'Numero CNH',
      type: 'string',
      visible: false,
    },
    {
      id: 'categoria',
      description: 'Categoria',
      type: 'select',
      visible: false,
    },
    {
      id: 'isfuncionario',
      description: 'Motorista',
      type: 'select',
      visible: false,
    },
    {
      id: 'nome',
      description: 'Nome',
      type: 'string',
      visible: true,
    },
    {
      id: 'cpf',
      description: 'Cpf',
      type: 'string',
      visible: true,
    },
    {
      id: 'matricula',
      description: 'Matricula',

      type: 'string',
      visible: true,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen = 'motorista'

  ngOnInit() {
    // this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    const model: any = {
      tipoMotoristaId: 0,
      // tipoMotoristaId: null,
    }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    if (model.cpf) {
      model.cpf = model.cpf
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          motorista:
            item.isFuncionario.toLowerCase() == 's'
              ? 'Funcionário'
              : 'Prestador',
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.driverService.listPagedDriver(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.driverService
      .searchPagedDriver(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newDriver() {
    const dialogRef = this.dialog.open(DriverCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(DriverEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
  }
}
